export const PRODUCT_SWITCH_RESTRICTION_TITLE = 'Switching Rock Maker Version';

export const PRODUCT_SWITCH_RESTRICTION_MESSAGE =
  'Feature unsupported in RM Lite. Returned to Home.';

export const PRODUCT_SWITCH_MODAL_ID = 'sidebar-switch-product-modal';

export const PRODUCT_SWITCH_BUSY_MESSAGE =
  'A process is currently running. Please wait until the process is completed, then try again.';

export const SWITCH_TO_RM_LITE_CONFIRM_MESSAGE =
  'You\u2019re about to switch to Rock Maker Lite Mode (some features may be limited). Continuing will refresh all open pages to switch them to Lite mode. Are you sure you want to proceed?';

export const SWITCH_TO_RM_FULL_CONFIRM_MESSAGE =
  'You\u2019re about to switch to Rock Maker (some features may become accessible). Continuing will refresh all open pages to switch them to full mode. Are you sure you want to proceed?';
